import {
  useUserContext,
  useAuthOptions,
} from '../../../../../contexts/UserContext';
import { useRouter } from 'next/router';

import { isOk } from '../../../../../domains/Result';
import { formatAuthorizationHeader } from '../../../../../helpers/auth';
import { fireToast } from '../../../../../helpers/Toasts';
import { orderRepository } from '../../../../../repositories/Order/OrderRepository';
import { HISTORY_CHECK_REPORT } from '../../../../../components/Toolkit/HistoryCheckModal/HistoryCheckModal.typed';

type useGreelightPurchaseProps = {
  registration: string;
};

export const useGreenlightPurchase = (props: useGreelightPurchaseProps) => {
  const { registration } = props;
  const { accessToken, handleLogin } = useAuthOptions();
  const { cookieBasedUser } = useUserContext();

  const router = useRouter();

  const handlePaymentUrl = async () => {
    if (!cookieBasedUser) {
      handleLogin(
        `/greenlight-history-check?api_request=history-check&registration=${registration}`,
      );
      return;
    }

    const historyReport = await orderRepository.historyReport(
      {
        type: HISTORY_CHECK_REPORT.STANDALONE_COMPLETE_REPORT,
        param: registration,
      },
      formatAuthorizationHeader(accessToken),
    );

    if (isOk(historyReport)) {
      const orderID = historyReport.ok.id;
      router.push(`/order/${orderID}`);
    } else {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  };

  return {
    handlePaymentUrl,
  };
};
